<template>
  <PflegeDownloadButton
    v-editable="props.blok"
    :data-uid="props.blok._uid"
    :download-url="handleDownloadPath"
    :download-label="props.blok.downloadLabel!"
    :tracking-label="trackingLabel"
  />
</template>

<script setup lang="ts">
import { PflegeDownloadButton } from '@webcarelbj/shared-components'
import { computed, inject } from 'vue'
import { AssetStoryblok, blokMainComponent, useTracking } from '../../'
import { BlokBase, BlokProps } from '../../types/blok'
import { downloadBtnOptions } from '../../types/injection-composables'

export interface DownloadButtonBlok extends BlokBase {
  downloadLabel?: string,
  downloadUrl?: AssetStoryblok
}

const props = defineProps<BlokProps<DownloadButtonBlok>>()

const downloadOpts = inject(downloadBtnOptions)!

const handleDownloadPath = computed(() => {
  let path = props.blok.downloadUrl?.filename
  if (!props.blok.downloadUrl?.is_external_url) {
    path = path?.replace('//a.storyblok.com', `//${downloadOpts.downloadDomainReplace}`)
  }

  return path ?? ''
})

const { prepareClickContext, createTrackingLabel } = useTracking()
const mainComponent = inject(blokMainComponent, null)

const trackingLabel = computed(() => {
  return `btn_${createTrackingLabel(props.blok.downloadLabel)}`
})

if (mainComponent) {
  prepareClickContext(
    'button',
    mainComponent.mainComponent.value,
    props.blok.downloadLabel ?? '',
  )
}
</script>
